import React from 'react';
import SoWEditor from './pages/SoWEditor/SoWEditor'; // Adjust path if necessary

function App() {
  return (
    <div className="App">
      <SoWEditor />
    </div>
  );
}

export default App;

